import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UiService } from '../services/ui.service';

/**
 * Guard for the special `/fulfillment` route: it opens the FulfillmentSheet as
 * a side effect and cancels the navigation (returns `false`), so the prior
 * screen stays mounted underneath the overlay instead of being replaced.
 */
export const openFulfillmentGuard: CanActivateFn = () => {
  inject(UiService).openFulfillment();
  return false;
};
